export const MESSAGE_TYPES = {
  ERROR: 0,
  SUCCESS: 1,
  WARNING: 2,
}
